import { Form } from 'antd';
import React, { FC } from 'react';
import { PICKER_DATE_MASK, SERVER_DATE_MASK } from 'shared/constants';
import { ISearchData } from 'shared/types/rvd.types';
import DatePickerWithDots from 'shared/components/datePickerWithDots/DatePickerWithDots';
import { Dayjs } from 'dayjs';
import { SelectOptions } from '../..';

type TProps = {
  onSearch: (data: string, key: keyof ISearchData) => void;
};

const DateSearch: FC<TProps> = ({ onSearch }) => {
  const onChange = (data: Dayjs | null) => {
    const formattedDate = data?.format(SERVER_DATE_MASK);
    onSearch(formattedDate || '', 'date');
  };

  return (
    <Form.Item name={SelectOptions.DATE_OPTION} className="detail-search-data-input">
      <DatePickerWithDots onChange={onChange} format={PICKER_DATE_MASK} />
    </Form.Item>
  );
};

export default DateSearch;
